import React, { useEffect } from 'react';
import { Box, Typography , Stack ,Button, Card, CardContent, Grid, } from '@mui/material';
import imgUrl from '../assets/images/imgUrl';
import { useNavigate } from "react-router";
import { LazyLoadImage } from 'react-lazy-load-image-component';
 
const imgUrls = [
  imgUrl.fincirc,
  imgUrl.balpharma,
  imgUrl.ecube,
  imgUrl.whiteSpoons,
  imgUrl.pharmveda,
  imgUrl.chablani,
  imgUrl.enersynk,
  imgUrl.pecan,
  imgUrl.kridzz,
  imgUrl.deal,
  imgUrl.blackSwan,
  imgUrl.kurves,
  imgUrl.siroya,
  imgUrl.stivaph,
];


const triangleItems = [
  {
    title: 'Intellectual depth',
    icon: <img src={imgUrl.peaceBulb}/>,
    bg: 'linear-gradient(135deg, #66d3f4, #203f4e)',
    textColor: 'white',
  },
  {
    title: 'Emotional appeal',
    icon: <img src={imgUrl.peaceHeart}/>,
    bg: '#D1DE5F',
    textColor: 'black',
  },
  {
    title: 'Practical realism',
    icon: <img src={imgUrl.peaceHand}/>,
    bg: 'linear-gradient(135deg, #66d3f4, #203f4e)',
    textColor: 'white',
  },
];

// peacekeeper pledge
const renderCircles = (count) =>
    [...Array(count)].map((_, index) => (
      <Grid item key={index}>
        <Card
          sx={{
            width: 70,
            height: 70,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 3,
          }}
        >
          <CardContent />
        </Card>
      </Grid>
));

const Home = () => {
  const navigate = useNavigate();

  // Clear base_pay_amount from localStorage when home page loads
  useEffect(() => {
    localStorage.removeItem('base_pay_amount');
    localStorage.removeItem('base_pay_amount_from_quickinfo');
    console.log('Cleared base_pay_amount from localStorage on home page');
  }, []);

  return (

    <>
    {/* Home section */}
    <Box
      className="homeSectionBg commonBannerBg"
      sx={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        // position: 'relative',
        color: 'white',
        px: 2,
      }}
    >
      {/* Mini Header (Top-Left) */}
      <Box
        sx={{
          position: 'absolute',
          top: 80,
          left: 0,
          display: 'flex',
          alignItems: 'center',
        }}
      >
         <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
       
      </Box>

     

    
    </Box>

    {/* peaceful movement section */}
    <Box
      sx={{
        position: 'relative',
        px: 3,
        py: 6,
        textAlign: 'center',
        backgroundColor: '#fff',
        overflow: 'hidden',
      }}
    >
     
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          opacity: 0.2,
          zIndex: 0,
        }}
        className="peaceSectionBg"
      />

      {/* Text Content */}
      <Typography
        variant="h6"
        component="blockquote"
        sx={{
          fontWeight: 400,
          color: '#2c2e35',
          position: 'relative',
          zIndex: 1,
          maxWidth: 800,
          margin: '0 auto',
          lineHeight: 1.5,
          fontSize:'30px'
        }}
      >
        <span style={{ fontWeight: 'bold', color: '#399746' }}>
          I Am Peacekeeper Movement
        </span>{' '}
        signifies the world’s mass grassroots Movement of Peace through the creation of the planet’s largest collective of peace advocates.
      </Typography>
    </Box>

    {/* peacekeeper triangle */}
     <Box
      sx={{
        py: 5,
        px: 3,
        paddingBottom:'0px',
        textAlign: 'center',
        // backgroundColor: '#eef7e3', 
      }}
      className="peaceMakerTriangleBg"
    >
      {/* Title */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: '400',
          color: '#0A8270',
          mb: 5,
        }}
        className='headingFont green-title'
      >
        Founded on the 28 Gems of World Peace:
        
      </Typography>

      {/* Triangle Circles */}
      {/* <Stack
        direction={{ xs: 'column', md: 'row' , sm: 'row' }}
        spacing={4}
        justifyContent="center"
        alignItems="center"
      >
        {triangleItems.map((item) => (
          <Box
            key={item.title}
            sx={{
              width: 160,
              height: 160,
              borderRadius: '50%',
              background: item.bg,
              color: item.textColor,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: 3,
              textAlign: 'center',
              p: 2,
            }}
          >
            {item.icon}
            <Typography variant="body1" sx={{ mt: 1, fontWeight: 500 }} className='peaceMakerCircleTitle'>
              {item.title}
            </Typography>
          </Box>
        ))}
      </Stack> */}

        {/* 28 GEMS OF WORLD PEACE Section */}
    <Box className="gems-section">
     
      {/* Four Categories Grid */}
      <Grid container spacing={4} className="gems-grid">
        {/* 7 Gems for Peace with Nations */}
        <Grid size={{ xs: 12, md: 6 , lg:6 }} className="gems-grid-item">
          <Box className="gems-card gems-card-nations">
            {/* Left Side - Large Number 7 */}
            <Box className="gems-number-container">
              <Typography variant="h1" className="gems-number gems-number-nations">
                7
              </Typography>
            </Box>
            
            {/* Right Side - Content */}
            <Box className="gems-content">
              <Typography variant="h5" className="gems-category-title gems-category-title-nations">
                Gems for Peace with Nations
              </Typography>
              <Box component="ul" className="gems-list">
                {[
                  'Reduction of defence budgets',
                  'Upholding human rights',
                  'Race, gender, caste, and culture equality',
                  'Abolition of child, drug, and woman trafficking and child labour',
                  'Promotion of travel, tourism, cross-cultural, and cross-national exchanges',
                  'Inclusive constitutional identity of nations',
                  'Introduction of worldwide values based education'
                ].map((gem, index) => (
                  <Box component="li" key={index} className="gems-list-item">
                    <Box className="gems-bullet gems-bullet-nations" />
                    {gem}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* 7 Gems for Peace with Law */}
        <Grid size={{ xs: 12, md: 6 , lg:6 }} className="gems-grid-item">
          <Box className="gems-card gems-card-law">
            {/* Left Side - Large Number 7 */}
            <Box className="gems-number-container">
              <Typography variant="h1" className="gems-number gems-number-law">
                7
              </Typography>
            </Box>
            
            {/* Right Side - Content */}
            <Box className="gems-content">
              <Typography variant="h5" className="gems-category-title gems-category-title-law">
                Gems for Peace with Law
              </Typography>
              <Box component="ul" className="gems-list">
                {[
                  'Justice - Fair treatment and equality for all',
                  'Integrity - Upholding moral and ethical principles',
                  'Freedom - The right to live without oppression or fear',
                  'Responsibility - Accountability for one\'s actions',
                  'Respect - Valuing the rights and dignity of others',
                  'Order - Maintaining societal structures and rules for peace',
                  'Compassion - Balancing law with empathy for humanity'
                ].map((gem, index) => (
                  <Box component="li" key={index} className="gems-list-item">
                    <Box className="gems-bullet gems-bullet-law" />
                    {gem}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* 7 Gems for Peace with People */}
        <Grid size={{ xs: 12, md: 6 , lg:6 }} className="gems-grid-item">
          <Box className="gems-card gems-card-people">
            {/* Left Side - Large Number 7 */}
            <Box className="gems-number-container">
              <Typography variant="h1" className="gems-number gems-number-people">
                7
              </Typography>
            </Box>
            
            {/* Right Side - Content */}
            <Box className="gems-content">
              <Typography variant="h5" className="gems-category-title gems-category-title-people">
                Gems for Peace with People
              </Typography>
              <Box component="ul" className="gems-list">
                {[
                  'Communication',
                  'Co-creation',
                   'Clarity',
                  'Co-existence',
                  'Character',
                 
                  'Calmness',
                  'Conscience'
                ].map((gem, index) => (
                  <Box component="li" key={index} className="gems-list-item">
                    <Box className="gems-bullet gems-bullet-people" />
                    {gem}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* 7 Gems for Peace with Oneself */}
        <Grid size={{ xs: 12, md: 6 , lg:6 }} className="gems-grid-item">
          <Box className="gems-card gems-card-oneself">
            {/* Left Side - Large Number 7 */}
            <Box className="gems-number-container">
              <Typography variant="h1" className="gems-number gems-number-oneself">
                7
              </Typography>
            </Box>
            
            {/* Right Side - Content */}
            <Box className="gems-content">
              <Typography variant="h5" className="gems-category-title gems-category-title-oneself">
                Gems for Peace with Oneself
              </Typography>
              <Box component="ul" className="gems-list">
                {[
                  'Gratitude',
                  'Forgiveness',
                   'Love',
                  'Humility',
                   'Giving',
                  'Patience',
                  
                 
                  'Truth',
                 
                ].map((gem, index) => (
                  <Box component="li" key={index} className="gems-list-item">
                    <Box className="gems-bullet gems-bullet-oneself" />
                    {gem}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

     
    </Box>
      
    </Box>   

  

    {/* peacekeeper patron */}

    <Box sx={{ textAlign: 'center', p: 4 }} className="peacekeeperPatronSection">
      {/* Peacekeeper PATRON Section */}
      <img src={imgUrl.peaceIcon} className='w-100 peaceImg'></img>
      <Typography variant="h6" sx={{ mb: 1 }} className='patronHeading green-title'>
        {/* I Am Peacekeeper PATRON: */}
        Official Advocates
      <br></br>
        I Am Peacekeeper Movement <br></br> & Global Initiatives

      </Typography>
      <Typography sx={{ mb: 2 }}>Thursday, 4th September 2025, Dubai
      </Typography>
      {/* <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
        {renderCircles(5)}
      </Grid> */}

      {/* Peacekeeper PARTNER Section */}
       {/* <img src={imgUrl.peaceIcon} className='w-100 peaceImg' mt={5}></img>
      <Typography variant="h6" sx={{ mb: 1 }} className='patronHeading green-title'>
        I Am Peacekeeper PARTNER:
       <br></br>
      
        Partners of Global Justice, <br></br> Love & Peace
        </Typography>
      <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
        {renderCircles(5)}
      </Grid> */}

      {/* logos partner section */}

      
          <div className='partnerOne '>
          <div className='logosPartners platinum'>
             <Typography>🏆 Platinum</Typography>
          </div>

          <div className='platinumPartners'>
              <LazyLoadImage
                        key={1}
                        src={`${imgUrl.microlab}`}
                        alt={`Image Alt-logo`}
                        className="media"
                        placeholderSrc={""}
                        effect="blur" // opacity | black-and-white
                      />

                <LazyLoadImage
                        key={2}
                        src={`${imgUrl.globalProperty}`}
                        alt={`Image Alt-logo`}
                        className="media pixelSmallImage"
                        placeholderSrc={""}
                        effect="blur" // opacity | black-and-white
                      />
            {/* <img src={imgUrl.microlab} alt='logo' loading="lazy"></img>
            <img src={imgUrl.globalProperty} alt='logo' loading="lazy"></img> */}
          </div>
          </div>

           <div className='partnerOne nextRow'>
          <div className='logosPartners silver'>
             <Typography> 🥈 Silver</Typography>
          </div>

          <div className='platinumPartners'>

            <LazyLoadImage
                        key={1}
                        src={`${imgUrl.bhima}`}
                        alt={`Image Alt-logo`}
                        className="media pixelSmallImage"
                        placeholderSrc={""}
                        effect="blur" // opacity | black-and-white
                      />

              <LazyLoadImage
                        key={1}
                        src={`${imgUrl.shukra}`}
                        alt={`Image Alt-logo`}
                        className="media shukraLogo"
                        placeholderSrc={""}
                        effect="blur" // opacity | black-and-white
                      />
            {/* <img src={imgUrl.bhima}  alt='logo' loading="lazy"></img>
            <img src={imgUrl.shukra}  alt='logo'></img> */}
          </div>
          </div>
    

          <div className='partnerOne nextRow'>
          <div className='logosPartners bronze'>
            <Typography> 🥉 Bronze</Typography>
          </div>

          <div className='platinumPartners bronzeLogos'>
            <Grid container alignItems="center" justifyContent="center" spacing={2} className="mobileGrid">
                 {imgUrls.slice(0,7).map((logo, index) => (
                  <Grid item xs={6} sm={3} md={2} lg={2} key={index}>
                    {/* <img src={logo} alt={`logo-${index}`}/> */}

                    <LazyLoadImage
                        key={index}
                        src={`${logo}`}
                        alt={`Image Alt-logo`}
                        className="media"
                        placeholderSrc={""}
                        effect="blur" // opacity | black-and-white
                      />
                  </Grid>
                ))}

            </Grid>
            <Grid container justifyContent="center" spacing={2}  className="mobileGrid">
                  {imgUrls.slice(7,14).map((logo, index) => (
                  <Grid item xs={6} sm={3} md={2} lg={2} key={index}>
                    {/* <img src={logo} alt={`logo-${index}`}/> */}
                    <LazyLoadImage
                        key={index}
                        src={`${logo}`}
                        alt={`Image Alt-logo`}
                        className="media"
                        placeholderSrc={""}
                        effect="blur" // opacity | black-and-white
                      />
                  </Grid>
                ))}
            </Grid>
          </div>
          </div>

          
           <div className='partnerOne nextRow'>
          <div className='logosPartners itPartners'>
             <Typography> 🖥️ IT Partner</Typography>
          </div>

          <div className='platinumPartners dureLogo'>
            {/* <img src={imgUrl.dure}  alt='logo' loading="lazy"></img> */}
            <LazyLoadImage
                        key={11}
                        src={`${imgUrl.dure}`}
                        alt={`Image Alt-logo`}
                        className="media"
                        placeholderSrc={""}
                        effect="blur" // opacity | black-and-white
                      />
          </div>
          </div>

     


      {/* Buttons */}
      <Grid container justifyContent="center" spacing={2} mb={5} mt={5}>
        <Grid>
          <Button
            variant="contained"
            className='blueButton'
            onClick={() => navigate("/login")}
          >
            Join the Movement
          </Button>
        </Grid>
        <Grid>
       
          <Button
            variant="contained"
            className='blueButton'
            onClick={() => navigate("/pledge")}
          >
            Take I Am Peacekeeper Pledge
          </Button>
        </Grid>
      </Grid>
    </Box>
    

    </>
  );
};

export default Home;
